module.exports = __webpack_public_path__ + "static/tetanus-e780d3544805210d4f312e42507a416f.png";